import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection4 from "./HeroSection4";
import VisualizationSection4 from "./VisualizationSection4";
import Contact from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";

const App4Page = () => {
  useEffect(() => {
    // Add 'biolingo-page' class to <body> for page-specific styles
    document.body.classList.add("happimeter-page");

    // Update the page title
    const previousTitle = document.title;
    document.title = "Happimeter - Know yourself better than you do now | Galaxy Advisors";

    // Scroll to the top of the page when this component loads
    window.scrollTo(0, 0);

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("happimeter-page");
      document.title = previousTitle; // Restore the previous title
    };
  }, []);

  return (
    <div>
      {/* SEO Metadata for Social Sharing and Search Engines */}
      <Helmet>
        <title>Happimeter - Know yourself better than you do now | Galaxy Advisors</title>
        <meta name="description" content="Discover Happimeter - mood body sensor tracker by Galaxy Advisors." />
        <meta property="og:title" content="Happimeter - Mood Wellness Tracker" />
        <meta property="og:description" content="AI-driven body sensor and mood well-being tracking." />
        <meta property="og:image" content="https://galaxyadvisors.com/happimeterPagePreview.png" />
        <meta property="og:url" content="https://galaxyadvisors.com/happimeter" />
      </Helmet>

      {/* Modularized Sections */}
      <HeroSection4 />
      <VisualizationSection4 />
      <Contact />
      <Footer />
    </div>
  );
};

export default App4Page;